import { render, staticRenderFns } from "./AccountHeader.vue?vue&type=template&id=89ddd8c2"
import script from "./AccountHeader.vue?vue&type=script&lang=js"
export * from "./AccountHeader.vue?vue&type=script&lang=js"
import style0 from "./AccountHeader.vue?vue&type=style&index=0&id=89ddd8c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VIcon})
